import { style, animate, trigger, transition, group } from '@angular/animations';

// Default times
const ENTRY_TIME = '0.4s';
const EXIT_TIME = '0.2s';
// ACTIONS - primitives to build animations with
function fadeInActions(options) {
    const defaultOptions = { time: ENTRY_TIME, type: 'ease-out' };
    const optionsToUse = { ...defaultOptions, ...options };
    return [style({ opacity: 0 }), animate(`${optionsToUse.time} ${optionsToUse.type}`, style({ opacity: 1 }))];
}
function fadeOutActions(options) {
    const defaultOptions = { time: EXIT_TIME, type: 'ease-in' };
    const optionsToUse = { ...defaultOptions, ...options };
    return [style({ opacity: 1 }), animate(`${optionsToUse.time} ${optionsToUse.type}`, style({ opacity: 0 }))];
}
function slideFromRightActions(options) {
    const defaultOptions = { time: ENTRY_TIME, type: 'ease-out', start: '-105%', end: '0' };
    const optionsToUse = { ...defaultOptions, ...options };
    return [style({ right: optionsToUse.start }), animate(`${optionsToUse.time} ${optionsToUse.type}`, style({ right: optionsToUse.end }))];
}
function slideFromLeftActions(options) {
    const defaultOptions = { time: ENTRY_TIME, type: 'ease-out', start: '-105%', end: '0' };
    const optionsToUse = { ...defaultOptions, ...options };
    return [style({ left: optionsToUse.start }), animate(`${optionsToUse.time} ${optionsToUse.type}`, style({ left: optionsToUse.end }))];
}
function scaleUpActions(options) {
    const defaultOptions = { time: ENTRY_TIME, type: 'ease-out', scaleStart: 0.9, scaleEnd: 1 };
    const optionsToUse = { ...defaultOptions, ...options };
    return [
        (style({ transform: `scale(${optionsToUse.scaleStart})` }),
            animate(`${optionsToUse.time} ${optionsToUse.type}`, style({ transform: `scale(${optionsToUse.scaleEnd})` }))),
    ];
}
function slideUpActions(options) {
    const defaultOptions = { time: ENTRY_TIME, type: 'ease-out', distance: '2rem' };
    const optionsToUse = { ...defaultOptions, ...options };
    return [style({ top: optionsToUse.distance }), animate(`${optionsToUse.time} ${optionsToUse.type}`, style({ top: '0' }))];
}
// ANIMATIONS - bundled animation actions with configuration options
function animationFadeIn(options) {
    return trigger('animationFadeIn', [transition(':enter', [...fadeInActions(options)])]);
}
function animationFadeInOut(options) {
    return trigger('animationFadeInOut', [
        transition(':enter', fadeInActions(options?.fadeInOptions)),
        transition(':leave', fadeOutActions(options?.fadeOutOptions)),
    ]);
}
function animationFadeInUp(options) {
    return trigger('animationFadeInUp', [
        transition(':enter', [group([...fadeInActions(options?.fadeInOptions), ...slideUpActions(options?.slideUpOptions)])]),
        transition(':leave', fadeOutActions(options?.fadeOutOptions)),
    ]);
}
function animationScaleUp(options) {
    return trigger('animationScaleUp', [
        transition(':enter', [group([...fadeInActions(options?.fadeInOptions), ...scaleUpActions(options?.scaleUpOptions)])]),
        transition(':leave', fadeOutActions(options?.fadeOutOptions)),
    ]);
}
function animationScaleSlideUp(options) {
    return trigger('animationScaleSlideUp', [
        transition(':enter', [
            group([
                ...fadeInActions(options?.fadeInOptions),
                ...scaleUpActions({ type: 'ease-in-out', ...options?.scaleUpOptions }),
                ...slideUpActions({ distance: '1rem', type: 'ease-in-out', ...options?.slideUpOptions }),
            ]),
        ]),
        transition(':leave', fadeOutActions(options?.fadeOutOptions)),
    ]);
}
class E11Animations {
    static { this.fadeInActions = fadeInActions; }
    static { this.fadeOutActions = fadeOutActions; }
    static { this.slideRightActions = slideFromRightActions; }
    static { this.scaleUpActions = scaleUpActions; }
    static { this.slideUpActions = slideUpActions; }
    static { this.fadeIn = [animationFadeIn()]; }
    static { this.fadeInOut = [animationFadeInOut()]; }
    static { this.fadeInUp = [animationFadeInUp()]; }
    static { this.scaleUp = [animationScaleUp()]; }
    static { this.scaleSlideUp = [animationScaleSlideUp()]; }
}
/**
 * @deprecated use E11Animations - clearer name
 */
class AnimationFading extends E11Animations {
}

/**
 * Generated bundle index. Do not edit.
 */

export { AnimationFading, E11Animations, animationFadeIn, animationFadeInOut, animationFadeInUp, animationScaleSlideUp, animationScaleUp, fadeInActions, fadeOutActions, scaleUpActions, slideFromLeftActions, slideFromRightActions, slideUpActions };
